import script from "./LandingPageLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPageLayout.vue?vue&type=script&setup=true&lang=js"

import "./LandingPageLayout.vue?vue&type=style&index=0&id=4eb3dd48&lang=scss"

const __exports__ = script;

export default __exports__